/**
 * ============================================================
 * ESENCIA — REGALO VISIBLE EN CARRITO V1
 * ============================================================
 *
 * Convierte el producto-regalo automático en una tarjeta premium.
 *
 * - Muestra imagen.
 * - Muestra nombre.
 * - Muestra REGALO ESPECIAL.
 * - Muestra GRATIS.
 * - No muestra + / -.
 * - No muestra eliminar.
 * - No cuenta como pieza.
 *
 * ============================================================
 */

(() => {

  'use strict';


  if (window.__ESENCIA_GIFT_CART_VISUAL_V1__) {
    return;
  }

  window.__ESENCIA_GIFT_CART_VISUAL_V1__ = true;



  /* ============================================================
     SOLO CARRITO
     ============================================================ */

  const path =
    window.location.pathname.replace(/\/+$/, '');


  if (
    path !== '/cart' &&
    !path.endsWith('/cart')
  ) {
    return;
  }



  /* ============================================================
     ESTILOS
     ============================================================ */

  function injectStyles() {

    if (
      document.getElementById(
        'esencia-gift-cart-visual-styles'
      )
    ) {
      return;
    }


    const style =
      document.createElement('style');


    style.id =
      'esencia-gift-cart-visual-styles';


    style.textContent = `

      /*
       * ======================================================
       * TARJETA REGALO
       * ======================================================
       */

      .esencia-cart-products
      .esencia-cart-item--gift {

        display: grid !important;

        position: relative !important;

        overflow: hidden !important;

        border:
          1.5px solid
          rgba(232, 121, 233, .42) !important;

        background:
          linear-gradient(
            135deg,
            rgba(232,121,233,.19) 0%,
            rgba(255,255,255,.97) 48%,
            rgba(250,212,250,.32) 100%
          ) !important;

        box-shadow:
          0 14px 35px
          rgba(185,73,186,.12) !important;

      }


      .esencia-cart-products
      .esencia-cart-item--gift::before {

        content: "";

        position: absolute;

        top: 0;
        left: 0;

        width: 5px;
        height: 100%;

        background:
          linear-gradient(
            180deg,
            #e879e9,
            #b94dba
          );

      }



      /*
       * ======================================================
       * IMAGEN
       * ======================================================
       */

      .esencia-cart-products
      .esencia-cart-item--gift
      .cart-items__media {

        align-self: center !important;

      }


      .esencia-cart-products
      .esencia-cart-item--gift
      .esencia-cart-media {

        background:
          rgba(255,255,255,.92) !important;

        border:
          1px solid
          rgba(232,121,233,.22) !important;

        border-radius:
          18px !important;

        padding:
          6px !important;

        box-shadow:
          0 7px 20px
          rgba(96,59,96,.07) !important;

      }



      /*
       * ======================================================
       * BADGE
       * ======================================================
       */

      .esencia-gift-cart-badge {

        display:
          inline-flex;

        align-items:
          center;

        gap:
          5px;

        width:
          fit-content;

        margin:
          0 0 5px;

        padding:
          5px 9px;

        border-radius:
          999px;

        color:
          #ffffff;

        background:
          linear-gradient(
            135deg,
            #e879e9,
            #c852ca
          );

        font-family:
          'DM Sans',
          sans-serif;

        font-size:
          9px;

        font-weight:
          800;

        line-height:
          1;

        letter-spacing:
          .08em;

        text-transform:
          uppercase;

      }



      /*
       * ======================================================
       * NOMBRE
       * ======================================================
       */

      .esencia-cart-products
      .esencia-cart-item--gift
      .esencia-cart-product-title {

        color:
          #603b60 !important;

        font-weight:
          800 !important;

      }



      /*
       * ======================================================
       * MENSAJE
       * ======================================================
       */

      .esencia-gift-cart-note {

        display:
          block;

        margin-top:
          5px;

        color:
          #7a587a;

        font-family:
          'DM Sans',
          sans-serif;

        font-size:
          10px;

        font-weight:
          600;

        line-height:
          1.35;

      }


      .esencia-gift-cart-note strong {

        color:
          #c852ca;

        font-weight:
          850;

      }



      /*
       * ======================================================
       * GRATIS
       * ======================================================
       */

      .esencia-cart-products
      .esencia-cart-item--gift
      .esencia-cart-price__gift {

        display:
          inline-flex !important;

        align-items:
          center;

        justify-content:
          center;

        padding:
          7px 10px;

        border-radius:
          999px;

        color:
          #ffffff !important;

        background:
          #e879e9 !important;

        font-family:
          'DM Sans',
          sans-serif !important;

        font-size:
          10px !important;

        font-weight:
          900 !important;

        letter-spacing:
          .04em;

      }



      /*
       * ======================================================
       * SIN CONTROLES
       * ======================================================
       */

      .esencia-cart-products
      .esencia-cart-item--gift
      .cart-items__quantity {

        display:
          none !important;

      }


      .esencia-cart-products
      .esencia-cart-item--gift
      quantity-selector,

      .esencia-cart-products
      .esencia-cart-item--gift
      quantity-input,

      .esencia-cart-products
      .esencia-cart-item--gift
      .quantity-selector,

      .esencia-cart-products
      .esencia-cart-item--gift
      .quantity,

      .esencia-cart-products
      .esencia-cart-item--gift
      cart-remove-button,

      .esencia-cart-products
      .esencia-cart-item--gift
      .cart-items__remove {

        display:
          none !important;

      }



      /*
       * ======================================================
       * MOBILE
       * ======================================================
       */

      @media screen and (max-width: 749px) {

        .esencia-cart-products
        .esencia-cart-item--gift {

          grid-template-columns:
            74px
            minmax(0,1fr) !important;

          grid-template-areas:
            "media details"
            "media price"
            "error error" !important;

          column-gap:
            11px !important;

          row-gap:
            5px !important;

          padding:
            12px !important;

        }


        .esencia-cart-products
        .esencia-cart-item--gift
        .cart-items__price {

          justify-self:
            start !important;

        }

      }



      /*
       * ======================================================
       * DESKTOP
       * ======================================================
       */

      @media screen and (min-width: 750px) {

        .esencia-cart-products
        .esencia-cart-item--gift {

          grid-template-columns:
            96px
            minmax(0,1fr)
            110px !important;

          grid-template-areas:
            "media details price"
            "media details error" !important;

          align-items:
            center !important;

          padding:
            16px !important;

        }

      }

    `;


    document.head.appendChild(
      style
    );

  }



  /* ============================================================
     OBTENER NIVEL
     ============================================================ */

  function getTierFromLine(
    line
  ) {

    const title =
      line.querySelector(
        '.esencia-cart-product-title'
      );


    const titleText =
      String(
        title?.textContent || ''
      );


    const match =
      titleText.match(
        /regalo\\s+esencia\\s+(5|10|15)/i
      );


    if (match) {
      return match[1];
    }


    const link =
      line.querySelector(
        'a[href*="/products/"]'
      );


    const href =
      String(
        link?.getAttribute('href') ||
        ''
      );


    if (
      href.includes(
        'regalo-esencia-15'
      )
    ) {
      return '15';
    }


    if (
      href.includes(
        'regalo-esencia-10'
      )
    ) {
      return '10';
    }


    if (
      href.includes(
        'regalo-esencia-parches-rhode'
      )
    ) {
      return '5';
    }


    return '';

  }



  /* ============================================================
     DECORAR TARJETA
     ============================================================ */

  function decorateGiftLine(
    line
  ) {

    if (
      !line ||
      line.dataset.esenciaGiftDecorated === 'true'
    ) {
      return;
    }


    line.dataset.esenciaGiftDecorated =
      'true';


    /*
     * Forzamos visible porque cart-products.liquid
     * actualmente tiene display:none para regalos.
     */

    line.style.setProperty(
      'display',
      'grid',
      'important'
    );


    const tier =
      getTierFromLine(
        line
      );


    const title =
      line.querySelector(
        '.esencia-cart-product-title'
      );


    /*
     * Limpiamos:
     *
     * Regalo Esencia 5 — 2 pares...
     *
     * para mostrar:
     *
     * 2 pares...
     */

    if (title) {

      const cleaned =
        String(
          title.textContent || ''
        )
          .replace(
            /^\\s*Regalo\\s+Esencia\\s+(5|10|15)\\s*[—–-]\\s*/i,
            ''
          )
          .trim();


      if (cleaned) {

        title.textContent =
          cleaned;

      }

    }


    const info =
      line.querySelector(
        '.cart-items__product-info'
      )
      ||
      line.querySelector(
        '.cart-items__details'
      );


    if (!info) {
      return;
    }


    /*
     * Badge
     */

    if (
      !info.querySelector(
        '.esencia-gift-cart-badge'
      )
    ) {

      const badge =
        document.createElement(
          'div'
        );


      badge.className =
        'esencia-gift-cart-badge';


      badge.innerHTML =
        '✦ Regalo especial';


      info.prepend(
        badge
      );

    }


    /*
     * Mensaje
     */

    if (
      !info.querySelector(
        '.esencia-gift-cart-note'
      )
    ) {

      const note =
        document.createElement(
          'div'
        );


      note.className =
        'esencia-gift-cart-note';


      if (tier) {

        note.innerHTML =
          `Incluido <strong>GRATIS</strong> por completar tu Esencia ${tier}.`;

      } else {

        note.innerHTML =
          'Incluido <strong>GRATIS</strong> con tu Esencia.';

      }


      const titleWrap =
        info.querySelector(
          '.esencia-cart-product-title-wrap'
        );


      if (titleWrap) {

        titleWrap.insertAdjacentElement(
          'afterend',
          note
        );

      } else {

        info.appendChild(
          note
        );

      }

    }

  }



  /* ============================================================
     BUSCAR REGALOS
     ============================================================ */

  function decorateAll() {

    document
      .querySelectorAll(
        '.esencia-cart-item--gift, [data-esencia-gift="true"]'
      )
      .forEach(
        decorateGiftLine
      );

  }



  /* ============================================================
     OBSERVAR ACTUALIZACIONES DEL CARRITO
     ============================================================ */

  function startObserver() {

    const observer =
      new MutationObserver(
        () => {

          window.requestAnimationFrame(
            decorateAll
          );

        }
      );


    observer.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }



  /* ============================================================
     INICIO
     ============================================================ */

  function init() {

    injectStyles();

    decorateAll();

    startObserver();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once:
          true
      }
    );

  } else {

    init();

  }

})();